import { createContext, useContext, useState } from "react";

// 1️⃣ Create context
const AppContext = createContext(null);

// 2️⃣ Provider
export const AppProvider = ({ children }) => {
  const [selectedColumns, setSelectedColumns] = useState(new Set());
  const [selectedColumnsData, setSelectedColumnsData] = useState([]);
  const [reportSelect, setReportSelect] = useState(false);


  return (
    <AppContext.Provider
      value={{
        selectedColumns, 
        setSelectedColumns,
        selectedColumnsData,
        setSelectedColumnsData,
        reportSelect, setReportSelect
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

// 3️⃣ Custom hook to use the context
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within AppProvider");
  }
  return context;
};